module.exports = __webpack_public_path__ + "img/HZ-B5101.15269c4f.jpg";